import type { AirportType } from './types';

export const isCurrent = (
  origin: AirportType | Record<string, never>,
  current: AirportType | Record<string, never>,
): boolean => !!(origin.iata_code && origin.iata_code === current.iata_code);
